import { Box, Button, Grid, Typography } from "@mui/material";
import { Apple, GooglePlay } from "iconsax-react";
import AndroidIcon from "@mui/icons-material/Android";
import React from "react";
import { useTranslation } from "react-i18next";
import { useThemeProvider } from "../../../providers/ThemeProvider";
import { Stack } from "@mui/system";
import { LinkValues } from "../../../values/strings";
import { useLanguageProvider } from "../../../providers/LanguageProvider";
import { ReactSVG } from "react-svg";
import {
  CafeBazzarIconShapeComponent,
  MyketIconShapeComponent,
} from "../../shapes/StoreIconShapeComponent";

const DownloadAppsPageComponent = ({ title }) => {
  const { t, i18n } = useTranslation();
  const lang = useLanguageProvider();
  const theme = useThemeProvider();
  return (
    <Box
      marginY={{ md: 5, xs: 2 }}
      paddingX={{ md: 7, xs: 2 }}
      position="relative"
    >
      <Typography variant="h6">
        {title || t("dialogDownloadAppsTitle")}
      </Typography>
      <Box paddingX={{ md: 4, xs: 0 }} paddingY={10}>
        <Grid
          container
          alignContent="center"
          alignItems="center"
          rowSpacing={{ md: 0, xs: 4 }}
        >
          {/* <Grid container item md={6} xs={12}>
            <Box>
              <img
                sx={{ width: "75%" }}
                src={LinkValues.styles.images.applicationView.samsung(
                  i18n.resolvedLanguage
                )}
              />
            </Box>
          </Grid> */}
          <Grid item xs={12}>
            <Grid container item rowSpacing={8}>
              <Grid container item sm={4} xs={6} direction="column">
                <Button
                  disableRipple
                  color={"textButton"}
                  LinkComponent={"a"}
                  href={LinkValues.files.download.androidApk()}
                >
                  <Stack
                    spacing={2}
                    direction="column"
                    justifyContent="center"
                    alignItems="center"
                  >
                    <Apple variant="Bold" size={35} />
                    <Typography variant="title">{t("appStore")}</Typography>
                  </Stack>
                </Button>
              </Grid>
              <Grid container item sm={4} xs={6} direction="column">
                <Button
                  disableRipple
                  color={"textButton"}
                  LinkComponent={"a"}
                  href={LinkValues.files.download.androidApk()}
                >
                  <Stack
                    spacing={2}
                    direction="column"
                    justifyContent="center"
                    alignItems="center"
                  >
                    <AndroidIcon style={{ fontSize: "35px" }} />
                    <Typography variant="title">{t("androidApk")}</Typography>
                  </Stack>
                </Button>
              </Grid>
              <Grid container item sm={4} xs={6} direction="column">
                <Button
                  disableRipple
                  color={"textButton"}
                  LinkComponent={"a"}
                  href={LinkValues.externals.stores.googlePlay}
                >
                  <Stack
                    spacing={2}
                    direction="column"
                    justifyContent="center"
                    alignItems="center"
                  >
                    <GooglePlay variant="Bold" size={35} />
                    <Typography variant="title">{t("googlePlay")}</Typography>
                  </Stack>
                </Button>
              </Grid>
              {i18n.resolvedLanguage === "fa" && (
                <Grid container item sm={4} xs={6} direction="column">
                  <Button
                    disableRipple
                    color={"textButton"}
                    LinkComponent={"a"}
                    href={LinkValues.externals.stores.cafeBazzar}
                  >
                    <Stack
                      spacing={2}
                      direction="column"
                      justifyContent="center"
                      alignItems="center"
                    >
                      <CafeBazzarIconShapeComponent />
                      <Typography variant="title">{t("cafeBazzar")}</Typography>
                    </Stack>
                  </Button>
                </Grid>
              )}
              {i18n.resolvedLanguage === "fa" && (
                <Grid container item sm={4} xs={6} direction="column">
                  <Button
                    disableRipple
                    color={"textButton"}
                    LinkComponent={"a"}
                    href={LinkValues.externals.stores.myket}
                  >
                    <Stack
                      spacing={2}
                      direction="column"
                      justifyContent="center"
                      alignItems="center"
                    >
                      <MyketIconShapeComponent />
                      <Typography variant="title">{t("myket")}</Typography>
                    </Stack>
                  </Button>
                </Grid>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};
export default DownloadAppsPageComponent;
